import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette'
import useUser from '../../hooks/user/useUser'
import {  Image, List, Button, Pagination, Input, Loader, Dimmer, Modal, Form, Table } from 'semantic-ui-react'
import useInput from '../../hooks/common/useInput';

import profileImg from '../../img/profile.png'
import {Link} from 'react-router-dom'
import { useRouter } from '../../hooks/common/useRouter';
import Responsive from '../common/Responsive';
import moment from 'moment';

const UserBlock = styled(Responsive)`
    padding : 2rem;
    .page-bar{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .top{
        display : flex;
        justify-content : space-between;
    }
    .button-group{
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-start;
        margin-top: 1rem;
    }
`;

const ModalRowBlock = styled.div`
    display: flex;
    font-size: 1.25rem;
    margin-bottom: 1rem;
    label{
        font-weight: bold;
        min-width: 120px;
    }
`

const User = () => {
    const {userList, open, show, close, focus, invalidate, onReadExcel, inputRef, onChangeExcelInput, exportUserList, userInputRef, onReadUserExcel, onChangeUserExcelInput, password, handleRemoveUsers} = useUser();
    const router = useRouter();
    
    
    
    const search = useInput("search")
    if (userList[0] === false){
        return (
            <UserBlock>
                <Dimmer active inverted>
                    <Loader size='massive'>Loading</Loader>
                </Dimmer>
            </UserBlock>
        )
    };

    if ( localStorage.logged == null || localStorage.logged == "false" ){
        console.log(password);
        
        const pw = window.prompt('비밀번호를 입력해주세요');
        
        if (pw !== password){
            alert('비밀번호가 틀립니다.');
        }
        else{
            localStorage.logged = true;
        }
    }
    
    const getDateTime = (unixTime: number) : string => {
        console.log(new Date(unixTime));
        
        return moment(new Date(unixTime)).format('YYYY-MM-DD');
    }
    
    
    const filterUser = userList?.filter(user => user[1]?.name === search.value.trim() || user[1]?.phoneNum === search.value.trim());
    const users = filterUser?.map((user, i)=>{
        const {name, phoneNum, spot, registeredAt, points, logs} = user[1];

        const newPoint = logs?.reduce((acc, log) => {
            return (log.newPoint ?? 0) + acc;
        }, 0) ?? 0;

        const payPrice = logs?.reduce((acc, log) => {
            return (log.price ?? 0) + acc;
        }, 0) ?? 0;

        const usePoint = logs?.reduce((acc, log) => {
            return (log.usePoint ?? 0) + acc;
        }, 0) ?? 0;
        
        const accPoint = points?.reduce((acc, p) => {
            return (p.point ?? 0) + acc;
        }, 0) ?? 0;        

        let updateAt: string = "데이터없음"
        
        const disappearPoint = points?.reduce((acc, p) => {
            if ( moment().add(7, 'days') > moment(new Date(p.updatedAt)).add(invalidate, 'days')){
                acc[0] += p.point
            }
            if ( moment().add(30, 'days') > moment(new Date(p.updatedAt)).add(invalidate, 'days')){
                acc[1] += p.point
            }
            if ( moment().add(60, 'days') > moment(new Date(p.updatedAt)).add(invalidate, 'days')){
                acc[2] += p.point
            }
            if ( moment().add(90, 'days') > moment(new Date(p.updatedAt)).add(invalidate, 'days')){
                acc[3] += p.point
            }

            return acc;
        }, [
            {displayDate: '7일', point : 0}, 
            {displayDate: '30일', point : 0}, 
            {displayDate: '60일', point : 0}, 
            {displayDate: '90일', point : 0}
        ]);

        if ( logs && logs.length != 0 ){
            updateAt = moment(new Date(logs[logs.length - 1].date)).format('YYYY-MM-DD hh:mm');
        }

            return(
                <Table.Row>
                    <Table.Cell>
                        {phoneNum}
                    </Table.Cell>
                    <Table.Cell>
                        {updateAt}
                    </Table.Cell>
                    <Table.Cell>
                        {newPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " P"}
                    </Table.Cell>
                    <Table.Cell>
                        {payPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " 원"}
                    </Table.Cell>
                    <Table.Cell>
                        {usePoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " P"}
                    </Table.Cell>
                    <Table.Cell>
                        {spot}
                    </Table.Cell>
                    <Table.Cell>
                        {accPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " P"}
                    </Table.Cell>
                    <Table.Cell>
                        <Button onClick={() => show({...user[1], newPoint, payPrice, accPoint, usePoint, disappearPoint})}>상세보기</Button>
                    </Table.Cell>
                </Table.Row>
            )
    })


    
    return (
        <UserBlock>
            <p className="top">총 회원수 : {userList.length}명</p>
            <Input icon='search' fluid placeholder='핸드폰 번호 또는 전화번호로 조회' {...search}/>
            <div className='button-group'>
                <Button color='red' onClick={handleRemoveUsers}>유저 전체 삭제</Button>
                <Button color='instagram' onClick={onReadUserExcel}>회원 데이터 등록</Button>
                <Button color='linkedin' onClick={onReadExcel}>적립 데이터 등록</Button>
                <Button color='linkedin' basic onClick={exportUserList}>회원 데이터 추출</Button>
                <input type='file' ref={inputRef} onChange={onChangeExcelInput} style={{display: 'none'}}></input>
                <input type='file' ref={userInputRef} onChange={onChangeUserExcelInput} style={{display: 'none'}}></input>
            </div>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>핸드폰 번호</Table.HeaderCell>
                        <Table.HeaderCell>시간</Table.HeaderCell>
                        <Table.HeaderCell>적립 포인트</Table.HeaderCell>
                        <Table.HeaderCell>원 결제금액</Table.HeaderCell>
                        <Table.HeaderCell>사용 포인트</Table.HeaderCell>
                        <Table.HeaderCell>이용매장</Table.HeaderCell>
                        <Table.HeaderCell>현재잔여포인트</Table.HeaderCell>
                        <Table.HeaderCell>상세보기</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {users}
                </Table.Body>
            </Table>
            <Modal open={open} onClose={() => close()}>
                <Modal.Header>
                    상세보기
                </Modal.Header>
                <Modal.Content>
                    <ModalRowBlock>
                        <label>회원번호</label> {focus?.key}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>회원명</label> {focus?.name}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>핸드폰 번호</label> {focus?.phoneNum}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>가입 매장</label> {focus?.spot}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>회원 등급</label> {focus?.userLevel}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>총 결제 금액</label> {focus?.payPrice}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>총 적립 포인트</label> {focus?.newPoint}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>총 사용 포인트</label> {focus?.usePoint}
                    </ModalRowBlock>
                    <ModalRowBlock>
                        <label>잔여 포인트</label> {focus?.accPoint}
                    </ModalRowBlock>
                    <h3>
                        소멸예정 포인트
                    </h3>
                    {
                        focus?.disappearPoint?.map(disappear => (
                            <ModalRowBlock>
                                <label>{disappear.displayDate}</label> {disappear.point}
                            </ModalRowBlock>
                        ))
                    }
                </Modal.Content>
            </Modal>
        </UserBlock>
    )
}

export default User;